import React, { memo } from 'react';

import RichText from 'components/RichText/RichText';
import { TableSection as TableSectionTypes } from 'containers/PrivacyPage/PrivacyPage.types';

import * as S from './TableSection.styles';

export interface TableSectionProps {
  data: TableSectionTypes;
}

const defaultProps: Partial<TableSectionProps> = {};

const TableSection: React.FunctionComponent<TableSectionProps> = ({ data }) => {
  const column = column =>
    column?.trim().length >= 1 && (
      <S.Col>
        <RichText richText={column} />
      </S.Col>
    );

  return (
    <S.TableSectionWrapper>
      <S.Table>
        <S.HeadCol>{data.columnNames.column1}</S.HeadCol>
        <S.HeadCol>{data.columnNames.column2}</S.HeadCol>
        <S.HeadCol>{data.columnNames.column3}</S.HeadCol>
        <S.HeadCol>{data.columnNames.column4}</S.HeadCol>
        {data.rows.map(row => (
          <S.Row key={`${row.column1}-${row.column2}`}>
            {column(row.column1)}
            {column(row.column2)}
            {column(row.column3)}
            {column(row.column4)}
          </S.Row>
        ))}
      </S.Table>
    </S.TableSectionWrapper>
  );
};

TableSection.defaultProps = defaultProps;

export default memo(TableSection);
